import { Component, OnInit } from '@angular/core';
import { BridgeMode } from '@hg-com/xwc-js-bridge/dist/native-app.service';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import {
  ProgressStatus,
  ServedContentType,
} from '@hg-com/xwc-js-bridge/dist/modules';
import { ToastrService } from 'ngx-toastr';
import i18next from 'i18next';
import { AppUpdateService } from 'src/modules/shared/services/app-update.service';

@Component({
  selector: 'app-app-update',
  templateUrl: './app-update.component.html',
  styleUrls: ['./app-update.component.scss'],
})
export class AppUpdateComponent implements OnInit {
  // public contentPackStatus = ContentPackStatus.Undetermined;
  updateProgress = 0;
  // public contentPackStatusEnum = ContentPackStatus;
  appUpdate = '';
  showOverlay = false;

  constructor(
    private nativeIntegrationService: NativeIntegrationService,
    private toastr: ToastrService,
    private appUpdateService: AppUpdateService
  ) {}

  ngOnInit(): void {
    console.log('UPDATE CHECK');
    // check if we are in an app or in web mode
    if (this.nativeIntegrationService.native.mode > BridgeMode.Mock) {
      console.log('UPDATE CHECK IN NATIVE MODE');
      this.showOverlay = true;
      this.appUpdate = 'Checking';
      console.log(this.appUpdate);

      this.nativeIntegrationService.content.contentDownloadProgress.subscribe(
        (progress) => {
          console.log('[APP UPDATE]: Progress', progress);
          this.appUpdate = 'Downloading';
          console.log(this.appUpdate);

          if (progress.progress && progress.size) {
            this.updateProgress = Number(
              ((progress.progress / progress.size) * 100).toFixed(0)
            );
            console.log(this.updateProgress);
            console.log(this.appUpdate);
          }

          if (progress.status === -2 || progress.status === -1) {
            this.showOverlay = false;
            this.toastr.error(i18next.t('app-update.failed'));
          }

          if (progress.status === 4) {
            this.appUpdate = 'Finished';
            console.log(this.appUpdate);
            this.showOverlay = false;
            this.nativeIntegrationService.basics
              .restartWithContent$(ServedContentType.LocalZip)
              .then();
            return;
          }
        }
      );

      this.appUpdateService
        .checkForUpdate()
        .then(() => {
          this.appUpdate = 'Finished';
          console.log(this.appUpdate);
          this.showOverlay = false; // false
        })
        .catch((error) => {
          console.log('[APP UPDATE]: Error', error);
          this.showOverlay = false; // false
        });
    } else {
      this.appUpdateService.didCheckForUpdate$.next(true);
      this.showOverlay = false; // false
    }
  }
}
